import { type MutationHookOptions, useMutation } from "@apollo/client";
import {
  CreateOrganizationMutation,
  DeleteOrganizationsMutation,
  RestoreOrganizationsMutation,
  UpdateOrganizationMutation,
  UpdateOrganizationBillingRequisitesMutation,
} from "../graphql/mutations";
import type {
  UpdateOrganizationBillingRequisitesMutationType,
  UpdateOrganizationBillingRequisitesMutationVariablesType,
} from "@/types/graphql/admin.generated";

/**
 * Хуки для мутаций организаций
 * Базовая entity-логика без UI-специфики
 */

export function useCreateOrganizationMutation() {
  return useMutation(CreateOrganizationMutation);
}

export function useUpdateOrganizationMutation() {
  return useMutation(UpdateOrganizationMutation);
}

export function useDeleteOrganizationsMutation() {
  return useMutation(DeleteOrganizationsMutation);
}

export function useRestoreOrganizationsMutation() {
  return useMutation(RestoreOrganizationsMutation);
}

export function useUpdateOrganizationBillingRequisitesMutation(
  options?: MutationHookOptions<
    UpdateOrganizationBillingRequisitesMutationType,
    UpdateOrganizationBillingRequisitesMutationVariablesType
  >
) {
  return useMutation<
    UpdateOrganizationBillingRequisitesMutationType,
    UpdateOrganizationBillingRequisitesMutationVariablesType
  >(UpdateOrganizationBillingRequisitesMutation, options);
}
